import { Fragment, useState } from 'react';
import {
    Button, Box, Typography, Divider,
} from '@mui/material';
import { useGetIndicesQuery } from "../redux/reducers/indicesSlice";
import { FaFacebookSquare, FaInstagram, FaWhatsapp, FaMobileAlt, FaBan } from "react-icons/fa";
import Grid from "@mui/material/Grid";
import logo from "../logo.jpg";
import jsPDF from 'jspdf';
import dayjs from "dayjs";
import { getMinutaContrato, getConversionesCAC, CAC2nominal, nominal2CAC } from './index';
import theme from "../theme";
import _ from 'lodash'

import React, { PureComponent } from 'react';


const getLabel = (option) => {
    if (option.personaFisica) {
        if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
        return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
    } else {
        if (!option.denominacionSocial && !option.cuit) return option.email;
        return option.denominacionSocial + ' - ' + option.cuit;
    }
};
function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
};
const generatePDF = (id) => {
    return new Promise((resolve, reject) => {
        const report = new jsPDF('portrait', 'pt', 'a4');
        report.html(document.querySelector('#' + id)).then(() => {
            report.save('Minuta_Comercial.pdf');
            resolve(); // Resolvemos la promesa cuando se complete la generación del PDF
        }).catch((error) => {
            console.log(error);
            reject(error); // Rechazamos la promesa si hay un error
        });
    });
}
function getFecha(date) {
    date = new Date(parseInt(date)).toLocaleString().split(",");
    date = date[0].split("/");

    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let y = date[2];
    return d + '/' + m + '/' + y
};
function getMesAnio(mes, anio) {
    mes = mes + 1
    switch (parseInt(mes)) {
        case 1:
            mes = "ene";
            break;
        case 2:
            mes = "feb";
            break;
        case 3:
            mes = "mar";
            break;
        case 4:
            mes = "abr";
            break;
        case 5:
            mes = "may";
            break;
        case 6:
            mes = "jun";
            break;
        case 7:
            mes = "jul";
            break;
        case 8:
            mes = "ago";
            break;
        case 9:
            mes = "sep";
            break;
        case 10:
            mes = "oct";
            break;
        case 11:
            mes = "nov";
            break;
        default:
            mes = "dic";
            break;
    }
    return mes + '-' + anio
};
function getClaseContrato(id) {
    switch (parseInt(id)) {
        case 1:
        case 2:
            return id;
        case 3:
            return '3A';
        case 4:
            return '3B';
        case 5:
            return 'C'
        case 6:
            return 'B'
        default:
            return id
    }
}
function getClaseContratoDescripcion(clase) {
    switch (parseInt(clase.claseContratoId)) {
        case 1:
            return 'Est. Profesional';
        case 2:
            return '2 Ambientes';
        case 3:
            return '3 Ambientes';
        case 4:
            return '3 Ambientes Plus';
        default:
            return clase.descripcion
    }
}
const moneyFormatMinuta = (v) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((parseFloat(v)).toFixed(2)).replace("ARS", "");
//Minuta
export const MinutaContrato = ({ contrato, claseContrato, claseContratoConsolidada, estado, titulares, segundaHoja, contratoDpto, contratoCochera, contratoBaulera, claseCochera, claseBaulera, MESES_LAG, campanaPAEForm = null, }) => {
    const { data: indices } = useGetIndicesQuery();
    const getIndiceAt = (fecha = new Date(), difMeses = 0) => {
        function fechaNMesesAntes(ts, N) {
            let fecha = new Date(ts);
            fecha.setMonth(fecha.getMonth() + N);
            return fecha;
        };

        if (indices?.entities == null) return 1;
        fecha = new Date(typeof fecha === 'string' ? parseInt(fecha) : fecha);
        fecha = fechaNMesesAntes(fecha.getTime(), difMeses);
        return Object.values(indices?.entities || [])
            .filter(i => {
                const iFecha = new Date(parseInt(i.fecha));
                return iFecha.getFullYear() === fecha.getFullYear() && iFecha.getMonth() === fecha.getMonth();
            }).sort((a, b) => a.fecha - b.fecha)[0];
    };
    const CAC2Nominal = (cac, fecha) => cac * getIndiceAt(fecha, -2).cac;
 // MINUTA POR PRODUCTO

    // Porcentaje por producto
    let totalValor = claseContrato?.valorObjetoAhorroCAC
    totalValor += contrato.cochera ? claseCochera.valorObjetoAhorroCAC : 0
    totalValor += contrato.baulera ? claseBaulera.valorObjetoAhorroCAC : 0

    let perDpto = claseContrato?.valorObjetoAhorroCAC / totalValor
    let perCochera = contrato.cochera ? claseCochera.valorObjetoAhorroCAC / totalValor : 0
    let perBaulera = contrato.baulera ? claseBaulera.valorObjetoAhorroCAC / totalValor : 0
    //Dpto
    const estadoDpto = {
        adelantoInicialRestanteCAC: estado ? (estado.adelantoInicialRestanteCAC * perDpto) : null,
        cuotaEsperaMesRestanteCAC: estado ? (estado.cuotaEsperaMesRestanteCAC * perDpto) : null,
        indice: estado ? (estado.indice) : null,
        campanaPAE: campanaPAEForm ? campanaPAEForm : {}
    };
    const minutaDpto = estadoDpto ? getMinutaContrato(estadoDpto, contratoDpto, claseContrato) : null;
    //Cochera
    const estadoCochera = {
        adelantoInicialRestanteCAC: estado ? estado.adelantoInicialRestanteCAC * perCochera : null,
        cuotaEsperaMesRestanteCAC: estado ? estado.cuotaEsperaMesRestanteCAC * perCochera : null,
        indice: estado ? (estado.indice) : null,
        campanaPAE: campanaPAEForm ? campanaPAEForm : {}
    };
    const minutaCochera = estadoCochera ? getMinutaContrato(estadoCochera, contratoCochera, claseCochera) : null;
    //Baulera
    const estadoBaulera = {
        adelantoInicialRestanteCAC: estado ? estado.adelantoInicialRestanteCAC * perBaulera : null,
        cuotaEsperaMesRestanteCAC: estado ? estado.cuotaEsperaMesRestanteCAC * perBaulera : null,
        indice: estado ? (estado.indice) : null,
        campanaPAE: campanaPAEForm ? campanaPAEForm : {}
    };
    const minutaBaulera = estadoBaulera ? getMinutaContrato(estadoBaulera, contratoBaulera, claseBaulera) : null;


    //MINUTA CONSOLIDADA
    const [minuta, setMinuta] = useState(contrato && estado && claseContratoConsolidada ? getMinutaContrato({ ...estado, campanaPAE: campanaPAEForm ? campanaPAEForm : {} }, contrato, {...claseContratoConsolidada, perDpto: segundaHoja ? perDpto : 1}) : null)
    let mesCac = estado ? getMesAnio(new Date(parseInt(estado.indice?.fecha)).getMonth(), new Date(parseInt(estado.indice?.fecha)).getFullYear()) : '-'
    // MINUTA COMERCIAL CONSOLIDADA
    const cuota2 = getMesAnio(new Date(campanaPAEForm?.fechaInicio).getMonth(), new Date(parseInt(campanaPAEForm?.fechaInicio)).getFullYear())
    let titular = titulares[0]
    let aporteGeneral = (parseFloat(estado?.indice?.cac) / 100) * claseContratoConsolidada?.valorObjetoAhorroCAC
    let contratos = {
        suscripcion: {
            susMesCac: mesCac,
            indiceSus: parseFloat(estado?.indice?.cac) / 100
        },
        planAporte: {
            cuo: 1,
            apo: aporteGeneral / (350),
            //apo: aporteGeneral / (contrato?.refuerzo ? 350 : 300),
            ga: 1 / 350 * 100,
        },
        personalizacion: {
            seleccionAguinaldo: contrato?.refuerzo
        }
    };
    return (
        <>
            <Grid container direction="column" justifyContent="center" alignItems="center" style={{ zoom: "1.8", marginLeft: '5vh' }}>
                {/* <Grid container direction="column" justifyContent="center" alignItems="center" style={{ overflowX: 'hidden', overflowY: 'hidden', zoom: "1.8", visibility: "hidden" }}> */}
                <div className="content" id="minuta-comercial" style={{ width: "80vh", height: "900" }}>
                    {/* TÍTULO MINUTA */}
                    <Grid id="minuta-comercial-cotizador-hoja1" conteiner sx={{ width: "80vh", marginTop: "5vh", justifyContent: "flex-start", alignItems: "center", gap: "1px", display: "inline-flex" }}>
                        <Grid item>
                            <img style={{ width: "63px", height: "23px" }} src={logo} alt="Logo Edilia" />
                        </Grid>
                        <Grid item>
                            <Typography sx={{ width: "400px", marginLeft: "20vh", color: "black", fontSize: "12px", fontWeight: "bold", color: "#616161" }} >{`MINUTA COMERCIAL ${titulares.length === 0 ? 'CONSOLIDADA' : ' - ' + (titulares.find(t=> t.titularPrincipal)?.apellido)?.toUpperCase()}`}</Typography>
                        </Grid>
                    </Grid>
                    {/* Titular info */}
                    {titulares.length < 2 ? <Box sx={{
                        width: "90vh",
                        // height: "63px",
                        border: "1px solid grey",
                    }}>
                        <Grid conteiner
                            rowSpacing={0} sx={{
                                width: "90vh",
                                height: "15.5px",
                                display: "inline-flex",
                                justifyContent: "space-between",
                                alignItems: "strech"
                            }}>
                            <Grid item xs={2} >
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Titular Principal</Typography>
                            </Grid>
                            <Grid width="350" item xs={10}>
                                <Typography textAling="center" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{titular ? titular.juridica ? titular?.denominacionSocial?.toUpperCase() : titular?.nombre?.toUpperCase() + '  ' + titular?.apellido?.toUpperCase() : ''}</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ color: "grey", width: "89.9vh", }} />
                        <Grid conteiner sx={{
                            width: "90vh",
                            display: "inline-flex",
                            alignItems: "strech",
                        }}>
                            <Grid conteiner sx={{
                                display: "inline-flex",
                                justifyContent: "space-between",
                                alignItems: "strech"
                            }}>
                                <Grid item>
                                    <Typography sx={{
                                        width: "125px",
                                        fontSize: "6px",
                                        marginLeft: "6px",
                                        marginRight: "6px"
                                    }}>CUIT/CUIL Titular Principal</Typography>
                                </Grid>
                                <Grid item >
                                    <Typography sx={{
                                        width: "125px",
                                        fontSize: "6px",
                                        marginLeft: "6px",
                                        marginRight: "6px"
                                    }}>{titular?.cuit}</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ color: "#9e9e9e", with: "auto" }} orientation="vertical" />
                            <Grid conteiner sx={{
                                display: "inline-flex",
                                justifyContent: "space-between",
                                alignItems: "strech"
                            }}>
                                <Grid item>
                                    <Typography sx={{
                                        width: "125px",
                                        fontSize: "6px",
                                        marginLeft: "6px",
                                        marginRight: "6px"
                                    }}>Telefono</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography sx={{
                                        width: "125px",
                                        fontSize: "6px",
                                        marginLeft: "6px",
                                        marginRight: "6px"
                                    }}>{titular?.telefono1}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider sx={{ color: "#616161", width: "89.9vh", }} />
                        <Grid conteiner sx={{
                            width: "90vh",
                            height: "15.5px",
                            display: "inline-flex",
                            alignItems: "strech",
                            justifyContent: "space-between",
                        }}>
                            <Grid item xs={2} >
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Mail</Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{titular?.email}</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ color: "#9e9e9e", width: "89.9vh", }} />
                        <Grid conteiner sx={{
                            width: "90vh",
                            height: "15.5px",
                            display: "inline-flex",
                        }}>
                            <Grid item xs={2} >
                                <Typography sx={{
                                    width: "125px",
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Provincia</Typography>
                            </Grid>
                            <Grid item xs={5}>
                                <Typography sx={{
                                    width: "125px",
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{titular?.provincia}</Typography>
                            </Grid>

                            <Grid item xs={2} >
                                <Typography sx={{
                                    width: "125px",
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Ciudad</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography sx={{
                                    width: "125px",
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{titular?.ciudad}</Typography>
                            </Grid>
                        </Grid>
                    </Box> :
                        <Box sx={{
                            width: "90vh",
                            // height: "63px",
                            //border: "1px solid grey",
                            display: "inline-flex",
                            alignItems: "strech"
                        }}>
                            {titulares?.filter((t, i) => i < 2)?.map((titular, i) => {
                                return (
                                    <Fragment key={'MinutaComercialTitutalesHoja1' + i}>
                                        <Box sx={{
                                            width: "45vh",
                                            border: '1px solid grey'
                                        }}>
                                            <Grid conteiner
                                                rowSpacing={0} sx={{
                                                    width: "45vh",
                                                    height: "15.5px",
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid item xs={2} >
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>Titular {i + 1}</Typography>
                                                </Grid>
                                                <Grid width="175" item xs={10}>
                                                    <Typography textAling="center" sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>{titular ? titular.juridica ? titular?.denominacionSocial?.toUpperCase() : titular?.nombre?.toUpperCase() + '  ' + titular?.apellido?.toUpperCase() : ''}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Divider sx={{ color: "grey", width: "44.9vh", }} />
                                            <Grid conteiner sx={{
                                                width: "45vh",
                                                display: "inline-flex",
                                                alignItems: "strech",
                                            }}>
                                                <Grid conteiner sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                    <Grid item>
                                                        <Typography sx={{
                                                            width: "62.5px",
                                                            fontSize: "6px",
                                                            marginLeft: "6px",
                                                            marginRight: "6px"
                                                        }}>CUIT/CUIL Titular {i + 1}</Typography>
                                                    </Grid>
                                                    <Grid item >
                                                        <Typography sx={{
                                                            width: "62.5px",
                                                            fontSize: "6px",
                                                            marginLeft: "6px",
                                                            marginRight: "6px"
                                                        }}>{titular?.cuit}</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Divider sx={{ color: "#9e9e9e", with: "auto" }} orientation="vertical" />
                                                <Grid conteiner sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                    <Grid item>
                                                        <Typography sx={{
                                                            width: "30px",
                                                            fontSize: "6px",
                                                            marginLeft: "6px",
                                                            marginRight: "6px"
                                                        }}>Telefono</Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography textAlign={'left'} sx={{
                                                            width: "95px",
                                                            fontSize: "6px",
                                                            marginLeft: "6px",
                                                            marginRight: "6px"
                                                        }}>{titular?.telefono1}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Divider sx={{ color: "#9e9e9e", width: "44.9vh", }} />
                                            <Grid conteiner sx={{
                                                width: "45vh",
                                                height: "15.5px",
                                                display: "inline-flex",
                                                alignItems: "strech",
                                                justifyContent: "space-between",
                                            }}>
                                                <Grid item xs={2} >
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>Mail</Typography>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>{titular?.email}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Divider sx={{ color: "#9e9e9e", width: "44.9vh", }} />
                                            <Grid conteiner sx={{
                                                width: "45vh",
                                                height: "15.5px",
                                                display: "inline-flex",
                                            }}>
                                                <Grid item xs={2} >
                                                    <Typography sx={{
                                                        width: "62.5px",
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>Provincia</Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography sx={{
                                                        width: "62.5px",
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>{titular?.provincia}</Typography>
                                                </Grid>

                                                <Grid item xs={2} >
                                                    <Typography sx={{
                                                        width: "50px",
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>Ciudad</Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Typography sx={{
                                                        width: "75px",
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>{titular?.ciudad}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Fragment>)
                            })}
                        </Box>
                    }


                    {/* CAC*/}
                    <Box sx={{
                        marginTop: '5px',
                        width: "90vh",
                        // height: "31px",
                        border: "1px solid grey"
                    }}>
                        <Box
                            sx={{
                                display: "inline-flex",
                                justifyContent: "flex-start",
                                alingContent: "center"
                            }}>
                            <Box width="22vh">
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                }}>Fecha Suscripción</Typography>


                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                }}>Mes CAC</Typography>

                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                }}>CAC</Typography>
                            </Box>
                            <Box width="350px" alingContent="right">
                                <Typography textAlign="right" sx={{
                                    fontSize: "6px",
                                    marginRight: "6px"
                                }}>{getFecha(contrato?.fechaCreacion)}</Typography>

                                <Typography textAlign="right" sx={{
                                    fontSize: "6px",
                                    marginRight: "6px"
                                }}>{contratos?.suscripcion?.susMesCac}</Typography>
                                <Typography textAlign="right" sx={{
                                    fontSize: "6px",
                                    marginRight: "6px"
                                }}>{contratos?.suscripcion?.indiceSus}</Typography>
                            </Box>
                        </Box>
                    </Box>
                    {/* Tipología */}
                    <Box sx={{
                        marginTop: '5px',
                        marginBottom: '0px',
                        width: "90vh",
                        height: "15px",
                        border: "1px solid grey",
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        <Typography sx={{
                            fontSize: "6px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            fontWeight: "bold"
                        }}>1 - Suscripción y personalización inicial</Typography>
                    </Box>
                    <Box sx={{
                        width: "90vh",
                        marginTop: '0px',
                        // height: "31px",
                        border: "1px solid grey",
                        display: "inline-flex",
                    }}>
                        <Box sx={{
                            width: "20vh",
                            backgroundColor: theme.palette.success.main,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Typography sx={{
                                fontSize: "7px",
                                marginLeft: "6px",
                                marginRight: "6px",
                                fontWeight: "700",
                                color: "white"
                            }}>TIPOLOGÍA</Typography>
                        </Box>
                        <Box
                            sx={{
                                display: "inline-flex",
                                justifyContent: "flex-start"
                            }}>
                            <Box width="22vh">
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Tipología seleccionada</Typography>
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Clase</Typography>
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{claseContrato?.principal && segundaHoja ? 'Incluye Cochera' : ''}</Typography>
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{claseContrato?.principal && segundaHoja ? 'Incluye Baulera' : ''}</Typography>
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{(claseContrato?.principal && segundaHoja) && (contrato?.claseAspiracional?.descripcion !== claseContrato?.descripcion) ? 'Tipología Final Proyectada' : ''}</Typography>
                            </Box>
                            <Box width="225px" alingContent="center">
                                <Typography textAlign="center" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{claseContrato?.descripcion}</Typography>
                                <Typography textAlign="center" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{getClaseContrato(claseContrato?.claseContratoId)}</Typography>

                                <Typography textAlign="center" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{claseContrato?.principal && segundaHoja ? contrato?.cochera ? 'Sí' : 'No' : ''}</Typography>
                                <Typography textAlign="center" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{claseContrato?.principal && segundaHoja ? contrato?.baulera ? 'Sí' : 'No' : ''}</Typography>
                                <Typography textAlign="center" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{(claseContrato?.principal && segundaHoja) && (contrato?.claseAspiracional?.descripcion !== claseContrato?.descripcion) ? contrato?.claseAspiracional?.descripcion : ''}</Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Plan de aportes estandar */}
                    <Box sx={{
                        marginTop: '3px',
                        marginBottom: '0px',
                        width: "90vh",
                        display: "inline-flex",
                        justifyContent: "flex-end",

                        alignItems: "flex-end"
                    }}>
                        <Typography align="center" sx={{
                            width: "15vh",
                            fontSize: "6px",
                            marginRight: "5px"
                        }}>Aportes</Typography>
                        <Typography align="center" sx={{
                            width: "15vh",
                            fontSize: "6px",
                        }}>Cuota Referencia</Typography>
                        <Typography align="center" sx={{
                            width: "15vh",
                            fontSize: "6px",
                        }}>Grado de Avance (G.A. %)</Typography>
                    </Box>
                    <Box sx={{
                        width: "90vh",
                        marginTop: '0px',
                        // height: "31px",
                        border: "1px solid grey",
                        display: "inline-flex",
                    }}>
                        <Box width="22vh" sx={{
                            backgroundColor: theme.palette.success.main,
                            opacity: "5",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Typography align="center" sx={{
                                fontSize: "7px",
                                marginLeft: "6px",
                                marginRight: "6px",
                                fontWeight: "700",
                                color: "white"
                            }}>PLAN DE APORTES ESTANDAR</Typography>
                        </Box>
                        <Grid align="left" width="70vh" conteiner
                            sx={{
                                display: "inline-flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}>
                            <Grid
                                width="22vh"
                                container
                                direction="column"
                                justifyContent="flex-start"
                            >
                                <Typography textAling="left" sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                }}>APORTE DE REFERENCIA EN AHORRO</Typography>
                            </Grid>
                            <Grid
                                width="50vh"
                                container
                                direction="row"
                                display="inline-flex"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                            >
                                <Grid
                                    width="2vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>$</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>{moneyFormatMinuta(contratos?.planAporte?.apo?.toFixed(2))}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>{contratos?.planAporte?.cuo?.toFixed(2)}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>{contratos?.planAporte?.ga?.toFixed(3)} % </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* Personalizacion Ahorrro Mesual */}
                    <Box sx={{
                        width: "90vh",
                        marginTop: '5px',
                        // height: "31px",
                        border: "1px solid grey",
                        display: "inline-flex",
                    }}>
                        {/* CAJA VERDE */}
                        <Box width="22vh" sx={{
                            backgroundColor: theme.palette.success.main,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Typography align="center" sx={{
                                fontSize: "7px",
                                marginLeft: "6px",
                                marginRight: "6px",
                                fontWeight: "700",
                                color: "white"
                            }}>PERSONALIZACIÓN AHORRO MENSUAL</Typography>
                        </Box>
                        {/* DATOS */}
                        <Grid conteiner direction={"column"}>
                            <Grid item sx={{ width: "60vh", display: "inline-flex", justifyContent: "space-between" }}>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>SELECCIÓN AGUINALDO</Typography>
                                <Typography textAlign="center" sx={{ fontSize: "6px", fontWeight: "bold", paddingRight: "50px" }}>{contratos?.personalizacion?.seleccionAguinaldo ? 'Cuota Semestral' : 'Prorrateado Mensualmente'}</Typography>
                            </Grid>

                            <Grid item>
                                <Grid align="left" width="70vh" conteiner
                                    sx={{
                                        display: "inline-flex",
                                        justifyContent: "space-between",
                                        alignItems: "strech"
                                    }}>
                                    <Grid
                                        width="22vh"
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        alignItems="flex-start"
                                    >
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>APORTE MINIMO EN AHORRO</Typography>
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>APORTE MINIMO EN TENENCIA</Typography>
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>AGUINALDO - JUNIO Y DICIEMBRE</Typography>
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "bold"
                                        }}>APORTE MENSUAL PACTADO DURANTE AHORRO</Typography>
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>BONIFICACIÓN MENSUAL</Typography>
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>APORTE MENSUAL RECONOCIDO</Typography>
                                        <Typography sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>AGUINALDO - JUNIO Y DICIEMBRE</Typography>

                                    </Grid>
                                    <Grid
                                        width="50vh"
                                        container
                                        direction="row"
                                        display="inline-flex"
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                    >
                                        <Grid
                                            width="2vh"
                                            container
                                            direction="column"
                                            justifyContent="flex-end"
                                            alignItems="flex-start"
                                        >
                                            <Typography align="left" sx={{ fontSize: "7px", }}>$</Typography>
                                            <Typography align="left" sx={{ fontSize: "7px", }}>$</Typography>
                                            <Typography align="left" sx={{ fontSize: "7px", }}>$</Typography>
                                            <Typography align="left" sx={{ fontSize: "7px", fontWeight: "bold" }}>$</Typography>
                                            <Typography align="left" sx={{ fontSize: "7px", }}>$</Typography>
                                            <Typography align="left" sx={{ fontSize: "7px", }}>$</Typography>
                                            <Typography align="left" sx={{ fontSize: "7px", marginBottom: '5px' }}>$</Typography>
                                        </Grid>
                                        <Grid
                                            width="15vh"
                                            container
                                            direction="column"
                                            justifyContent="flex-end"
                                            alignItems="flex-end"
                                        >
                                            <Typography align="right" sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.aporteMinimoEnEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                            <Typography align="right" sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.aporteMinimoEnTenenciaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                            <Typography align="right" sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.aguinaldoRefuerzosCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                            <Typography align="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>{moneyFormatMinuta((minuta?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                            <Typography align="right" sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                            <Typography align="right" sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                            <Typography align="right" sx={{ fontSize: "7px", marginBottom: '5px' }}>{moneyFormatMinuta(((minuta?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                        </Grid>
                                        <Grid
                                            width="15vh"
                                            container
                                            direction="column"
                                            justifyContent="flex-end"
                                            alignItems="flex-end"
                                        >
                                            {/* <Typography sx={{ fontSize: "7px", }}>{(minuta?.qCuoRefPlan)}</Typography> */}
                                            <Typography sx={{ fontSize: "7px", marginTop: "7px" }}>{(minuta?.aporteMinimoEnEsperaCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteMinimoEnTenenciaCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aguinaldoRefuerzosCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                            <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>{(minuta?.aporteMensualPactadoEsperaCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.bonificacionMensualCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteMensualReconocidoCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                            <Typography sx={{ fontSize: "7px", marginBottom: '5px' }}>{((minuta?.aguinaldoRefuerzosCAC?.cuotasReferencia))?.toFixed(2)}</Typography>
                                        </Grid>
                                        <Grid
                                            width="15vh"
                                            container
                                            direction="column"
                                            justifyContent="flex-end"
                                            alignItems="flex-end"
                                        >

                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteMinimoEnEsperaCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteMinimoEnTenenciaCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aguinaldoRefuerzosCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                            <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>{(minuta?.aporteMensualPactadoEsperaCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.bonificacionMensualCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                            <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteMensualReconocidoCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                            <Typography sx={{ fontSize: "7px", marginBottom: '5px' }}>{((minuta?.aguinaldoRefuerzosCAC?.ga * 100))?.toFixed(3)} %</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* Adelanto Inicial */}
                    <Box sx={{
                        width: "90vh",
                        marginTop: '5px',
                        // height: "31px",
                        border: "1px solid grey",
                        display: "inline-flex",
                    }}>
                        <Box width="22vh" sx={{
                            backgroundColor: theme.palette.success.main,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"

                        }}>
                            <Typography align="center" sx={{
                                fontSize: "7px",
                                marginLeft: "6px",
                                marginRight: "6px",
                                fontWeight: "700",
                                color: "white"
                            }}>ADELANTO INICIAL</Typography>
                        </Box>
                        <Grid align="left" width="70vh" conteiner
                            sx={{
                                display: "inline-flex",
                                alignItems: "strech"
                            }}>
                            <Grid
                                width="22vh"
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="flex-start"
                            >
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    fontWeight: "bold"
                                }}>Adelanto Inicial</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>BONIFICACIÓN INICIAL</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>APORTE INICIAL RECONOCIDO</Typography>
                            </Grid>
                            <Grid
                                width="50vh"
                                container
                                direction="row"
                                display="inline-flex"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                            >
                                <Grid
                                    width="2vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-start"
                                >
                                    <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>$</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>$</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>$</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>{moneyFormatMinuta((minuta?.adelantoInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.bonificacionInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.aporteInicialReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>{(minuta?.adelantoInicialCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{(minuta?.bonificacionInicialCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteInicialReconocidoCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>{(minuta?.adelantoInicialCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{(minuta?.bonificacionInicialCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{(minuta?.aporteInicialReconocidoCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* Prima de Adjudicación */}
                    <Box sx={{
                        width: "90vh",
                        marginTop: '5px',
                        // height: "31px",
                        border: "1px solid grey",
                        display: "inline-flex",
                    }}>
                        <Box width="22vh" sx={{
                            backgroundColor: theme.palette.success.main,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Typography align="center" sx={{
                                fontSize: "7px",
                                marginLeft: "6px",
                                marginRight: "6px",
                                fontWeight: "700",
                                color: "white"
                            }}>PRIMA DE ADJUDICACIÓN</Typography>
                        </Box>
                        <Grid align="left" width="70vh" conteiner
                            sx={{
                                display: "inline-flex",
                                justifyContent: "space-between",
                                alignItems: "strech"
                            }}>
                            <Grid
                                width="22vh"
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="flex-start"
                            >
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                }}>% del bien como Prima de Adjudicación</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Saldo a Cancelar como Prima de Adjudicación</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Cuota prima de adjudicación (24 cuotas)</Typography>
                            </Grid>
                            <Grid
                                width="50vh"
                                container
                                direction="row"
                                display="inline-flex"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                            >
                                <Grid
                                    width="2vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-start"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>$</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>$</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>$</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>{moneyFormatMinuta((((minuta?.perBienPrimaDeAdjudicacionCAC?.aportes) / 100))?.toFixed(2))}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.saldoCancelarPrimaDeAdjudicacionCAC?.aportes / 100).toFixed(2))}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{moneyFormatMinuta((minuta?.cuotaPrimaAdjudicacionCAC?.aportes / 100).toFixed(2))}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>{((minuta?.perBienPrimaDeAdjudicacionCAC?.cuotasReferencia)?.toFixed(2)) || 0.00}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{minuta?.saldoCancelarPrimaDeAdjudicacionCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{minuta?.cuotaPrimaAdjudicacionCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", }}>{(((minuta?.perBienPrimaDeAdjudicacionCAC?.ga) / 100)?.toFixed(3)) || 0.00} %</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{(minuta?.saldoCancelarPrimaDeAdjudicacionCAC?.ga * 100).toFixed(3)} %</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{(minuta?.cuotaPrimaAdjudicacionCAC?.ga * 100).toFixed(3)} %</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* Puntos y capital licitatorio */}
                    <Box sx={{
                        width: "90vh",
                        marginTop: '5px',
                        // height: "31px",
                        border: "1px solid grey",
                        display: "inline-flex",
                    }}>
                        <Box width="22vh" sx={{
                            backgroundColor: theme.palette.success.main,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Typography align="center" sx={{
                                fontSize: "7px",
                                marginLeft: "6px",
                                marginRight: "6px",
                                fontWeight: "700",
                                color: "white"
                            }}>PUNTOS* Y CAPITAL LICITATORIO</Typography>
                        </Box>
                        <Grid align="left" width="70vh" conteiner
                            sx={{
                                display: "inline-flex",
                                justifyContent: "space-between",
                                alignItems: "strech"
                            }}>
                            <Grid
                                width="22vh"
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="flex-start"
                            >
                                <Typography sx={{
                                    fontSize: "6px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    fontWeight: "bold"
                                }}>CAPITAL LICITATORIO INICIAL (C.L.I.)</Typography>
                                <Typography sx={{
                                    fontSize: "5px",
                                    marginLeft: "30px",
                                    marginRight: "6px",
                                    fontWeight: "bold"
                                }}>SOLO DEPARTAMENTO</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    marginTop: '7px',
                                    marginBottom: '7px'
                                }}>PUNTOS INICIALES</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    fontWeight: "bold"
                                }}>Puntos Mensuales Proyectados</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "30px",
                                    marginRight: "6px"
                                }}>P.A. No Cancelada</Typography>
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "30px",
                                    marginRight: "6px"
                                }}>P.A. Cancelada</Typography>
                            </Grid>
                            <Grid
                                width="50vh"
                                container
                                direction="row"
                                display="inline-flex"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                            >
                                <Grid
                                    width="3vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-start"
                                >
                                    <Typography sx={{ fontSize: "7px", marginBottom: "10px" }}>$</Typography>
                                    <Typography sx={{ fontSize: "7px", color: 'white', marginTop: "7px" }}>.</Typography>
                                    <Typography sx={{ fontSize: "7px", color: 'white', marginTop: "7px" }}>.</Typography>
                                    <Typography sx={{ fontSize: "7px", color: 'white' }}>.</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", marginBottom: "10px" }}>{moneyFormatMinuta((minuta?.capitalLicitatorioInicial?.aportes / 100)?.toFixed(2))}</Typography>
                                    <Typography sx={{ fontSize: "7px", marginTop: "7px", color: 'white' }}>.</Typography>
                                    <Typography sx={{ fontSize: "7px", marginTop: "7px", color: 'white' }}>.</Typography>
                                    <Typography sx={{ fontSize: "7px", color: 'white' }}>.</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", marginBottom: "10px" }}>{(minuta?.capitalLicitatorioInicial?.cuotasReferencia)?.toFixed(2)}</Typography>
                                    <Typography sx={{ fontSize: "7px", marginBottom: "7px" }}>{(minuta?.puntosIniciales)?.toFixed(2)}</Typography>
                                    <Typography sx={{ fontSize: "7px", marginTop: "7px" }}>{minuta?.puntosMensualesProyectados?.PAnoCancelada?.toFixed(2)}</Typography>
                                    <Typography sx={{ fontSize: "7px", }}>{((minuta?.puntosMensualesProyectados?.PACancelada))?.toFixed(2)}</Typography>
                                </Grid>
                                <Grid
                                    width="15vh"
                                    container
                                    direction="column"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                >
                                    <Typography sx={{ fontSize: "7px", marginTop: "7px", marginBottom: "10px" }}>{(minuta?.capitalLicitatorioInicial?.ga * 100)?.toFixed(3)} %</Typography>
                                    <Typography sx={{ fontSize: "7px", marginTop: "7px", color: 'white' }}>.</Typography>
                                    <Typography sx={{ fontSize: "7px", marginTop: "7px", color: 'white' }}>.</Typography>
                                    <Typography sx={{ fontSize: "7px", color: 'white' }}>.</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>*Los puntos son para cada contrato (en caso de suscribir cochera o baulera)</Typography>



                    {/* ESQUEMA DE PUNTOS */}
                    <Typography sx={{ fontSize: "7px", fontWeight: "bold", marginTop: '10px', }}>ESQUEMA DE PUNTOS</Typography>
                    <Box sx={{
                        backgroundColor: theme.palette.success.main,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignConent: "center",
                        width: "90vh",
                        border: "1px solid grey",
                        alignItems: "strech"
                    }}>
                        <Typography sx={{
                            fontSize: "7px",
                            marginLeft: "6px",
                            marginRight: "30vh",
                            fontWeight: "700",
                            color: "white"
                        }}>Tipo de pago</Typography>
                        <Typography textAlign="right" sx={{
                            fontSize: "7px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            fontWeight: "700",
                            color: "white"
                        }}>Monto adelantado como G.A.%</Typography>
                        <Typography textAlign="right" sx={{
                            width: "30vh",
                            fontSize: "7px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            fontWeight: "700",
                            color: "white"
                        }}>PUNTOS</Typography>
                    </Box>
                    <Box sx={{
                        width: "90vh",
                        marginTop: '0px',
                        margin: "0",
                        padding: "0",
                        // height: "31px",
                        border: "1px solid grey",
                    }}>
                        <Grid width="90vh" conteiner
                            sx={{
                                margin: "0",
                                padding: "0",
                                display: "inline-flex",
                            }}>
                            <Grid
                                width="245px"
                                container
                                direction="column"
                                justifyContent="flex-start"
                            >
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Adelanto Inicial</Typography>

                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Adelanto Recurrente</Typography>

                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Adelanto Esporádico</Typography>
                            </Grid>
                            <Grid
                                width="35vh"
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="center"
                            >
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    color: "white"
                                }}>.</Typography>

                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{(minuta?.esquemaPuntos?.montoAdelantadoGa)?.toFixed(3)} %</Typography>

                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    color: "white"
                                }}>.</Typography>
                            </Grid>
                            <Grid
                                width="35vh"
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="flex-end"
                            >
                                <Typography textAlign="right" sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{minuta?.esquemaPuntos?.adelantoInicial}</Typography>

                                <Typography textAlign="right" sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{minuta?.esquemaPuntos?.adelantoRecurrente}</Typography>

                                <Typography textAlign="right" sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{minuta?.esquemaPuntos?.adelantoEsporadico}</Typography>
                            </Grid>
                        </Grid>

                        <Divider width="625vh" sx={{ color: "#9e9e9e" }}></Divider>

                        <Grid width="90vh" conteiner
                            sx={{
                                margin: "0",
                                padding: "0",
                                display: "inline-flex",
                            }}>
                            <Grid
                                width="245px"
                                container
                                direction="column"
                                justifyContent="flex-start"
                            >
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Cupón pago tiempo y forma</Typography>

                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>Puntos por referir un cliente</Typography>
                            </Grid>
                            <Grid
                                width="35vh"
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="center"
                            >
                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>n/a</Typography>

                                <Typography sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px",
                                    color: "white"
                                }}>.</Typography>

                            </Grid>
                            <Grid
                                width="35vh"
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="right"
                            >
                                <Typography textAlign="right" sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{minuta?.esquemaPuntos?.cuponPagoTiempoForma}</Typography>

                                <Typography textAlign="right" sx={{
                                    fontSize: "7px",
                                    marginLeft: "6px",
                                    marginRight: "6px"
                                }}>{minuta?.esquemaPuntos?.puntosReferido}</Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* FOOTER */}
                    <Box sx={{
                        width: "90vh",
                        marginTop: '60px',
                        paddingBottom: "15vh",
                        height: "31px",
                        display: "inline-flex",
                    }}>
                        <Grid conteiner width="175px" direction="column">
                            <Typography textAlign="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>Firma Supervisor Comercial</Typography>
                            <Typography textAlign="right" sx={{ fontSize: "7px", }}>Primera Junta 475, Torre D, Dpto. 602, Sensum</Typography>
                            <Typography textAlign="right" sx={{ fontSize: "7px", }}>Quilmes | Buenos Aires </Typography>
                            <Typography textAlign="right" sx={{ fontSize: "7px", }}>Argentina</Typography>
                        </Grid>
                        <Grid conteiner width="22vh" direction="column">
                            <Typography textAlign="right" sx={{ fontSize: "7px", marginTop: "12px" }}>www.edilia.com.ar | hola@edilia.com.ar</Typography>
                            <Typography textAlign="right" sx={{ fontSize: "7px", }}>< FaMobileAlt /> <FaWhatsapp />( + 54 9 11 ) 3448 9000</Typography>
                            <Typography textAlign="right" sx={{ fontSize: "7px", }}><FaFacebookSquare /><FaInstagram />@sistemaedilia</Typography>
                        </Grid>
                        <Grid conteiner width="120px" direction="column">
                            <Typography textAlign="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>Firma Cliente</Typography>
                        </Grid>
                    </Box>
                    {segundaHoja ? <>
                        {/* SEGUNDA PÁGINA */}

                        <div class="html2pdf__page-break"></div>
                        {/* TÍTULO APORTES X PROODUCTO */}
                        <Grid id="minuta-comercial-cotizador-hoja2" conteiner sx={{ width: "80vh", height: "23px", left: "15vh", marginTop: "100px", justifyContent: "flex-start", alignItems: "center", gap: "1px", display: "inline-flex" }}>
                            <Grid item>
                                <img style={{ width: "63px", height: "23px" }} src={logo} alt="Logo Edilia" />
                            </Grid>
                            <Grid item>
                                <Typography sx={{ width: "350px", marginLeft: "20vh", color: "black", fontSize: "12px", fontWeight: "bold", color: "#616161" }}>ASIGNACIÓN DE APORTES POR PRODUCTO</Typography>
                            </Grid>
                        </Grid>

                        <Box sx={{
                            marginTop: '5px',
                            width: "80vh",
                            display: "inline-flex",
                            justifyContent: "flex-start",
                        }}>

                            {/* TÍTULOS CAJA IZQUIERDA */}
                            <Box sx={{
                                width: "30vh",
                            }}>
                                {/* TITULARES */}
                                <Box sx={{
                                    width: "30vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    {titulares?.map((titular, i) => {
                                        return (
                                            <Fragment key={'Titular-Titulo' + i}>
                                                <Grid conteiner
                                                    rowSpacing={0} sx={{
                                                        width: "90vh",
                                                        height: "15.5px",
                                                        display: "inline-flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "strech"
                                                    }}>
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>Titular</Typography>
                                                </Grid>
                                                <Divider sx={{ color: "grey", width: "188px", }} />
                                            </Fragment>)
                                    })}
                                </Box>


                                {/* FECHA SUSCRIPCION*/}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "30vh",
                                    // height: "31px",
                                    border: "1px solid grey"
                                }}>
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alingContent: "center"
                                        }}>
                                        <Box width="80px">
                                            <Typography sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>Fecha Suscripción</Typography>
                                        </Box>
                                        <Box alingContent="right">
                                            <Typography textAlign="right" sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>{getFecha(contrato?.fechaCreacion)}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* ESPACIO */}
                                <Box sx={{
                                    marginTop: '0px',
                                    marginBottom: '0px',
                                    width: "30vh",
                                    display: "inline-flex",
                                    justifyContent: "flex-start"
                                }}>
                                    <Typography align="center" sx={{
                                        width: "15vh",
                                        fontSize: "6px",
                                        marginLeft: "3px",
                                        marginRight: "3px",
                                        color: "white"
                                    }}>.</Typography>
                                </Box>


                                {/* APORTE DE REFERENCIA */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '5px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>APORTE DE REFERENCIA</Typography>
                                    </Box>
                                    <Grid align="left" width="115px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>VALOR CUOTA del PLAN DE APORTES ESTANDAR (PAE)</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* PRIMA DE ADJUDICACIÓN */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '6px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>PRIMA DE ADJUDICACIÓN</Typography>
                                    </Box>
                                    <Grid align="left" width="115px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                marginTop: "2px",
                                                marginBottom: "2px",
                                            }}>% DEL BIEN</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>VALOR CUOTA ADJUDICACION (24 en total)</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* ADELANTO INICIAL */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '9px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>ADELANTO INICIAL</Typography>
                                    </Box>
                                    <Grid align="left" width="115px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                fontWeight: "bold"
                                            }}>INTEGRADO</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>BONIFICADO</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>RECONOCIDO</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* APORTES MINIMOS PERSONALIZADOS */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '9px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>APORTES MINIMOS PERSONALIZADOS</Typography>
                                    </Box>
                                    <Grid align="center" width="175px" conteiner
                                        sx={{
                                            alignItems: "flex-start"
                                        }}>
                                        <Typography textAlign={"left"} sx={{
                                            fontSize: "7px",
                                            fontWeight: "bold",
                                            marginLeft: "6px",
                                        }}>TIPO DE REFUERZO</Typography>
                                        <Grid align="left" width="130px" conteiner
                                            sx={{
                                                display: "inline-flex",
                                                justifyContent: "space-between",
                                                alignItems: "strech"
                                            }}>
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                alignItems="flex-start"
                                            >
                                                <Typography sx={{
                                                    fontSize: "7px",
                                                    marginLeft: "6px",
                                                    marginRight: "6px",
                                                }}>en AHORRO</Typography>
                                                <Typography sx={{
                                                    fontSize: "7px",
                                                    marginLeft: "6px",
                                                    marginRight: "6px",
                                                }}>en TENENCIA</Typography>
                                                <Typography sx={{
                                                    fontSize: "7px",
                                                    marginLeft: "6px",
                                                    marginRight: "6px",
                                                }}>REFUERZOS - ENERO Y JULIO</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* APORTES PACTADOS EN AHORRO */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '9px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>APORTES PACTADOS EN AHORRO</Typography>
                                    </Box>
                                    <Grid align="left" width="120px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                fontWeight: "bold"
                                            }}>APORTE MENSUAL</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>BONIFICACIÓN</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>TOTAL RECONOCIDO</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                            }}>REFUERZOS - ENERO Y JULIO</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                            {/* FIN CAJA IZQUIERDA */}

                            {/* DATOS CAJA DERECHA*/}
                            <Box sx={{
                                width: "30vh",
                                marginLeft: "5px"
                                // height: "63px",
                            }}>

                                {/* TITULARES */}
                                <Box sx={{
                                    width: "60vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    {titulares?.map((titular, i) => {
                                        return (
                                            <Fragment key={'Titular-nombre-minuta-hoja2-' + i}>
                                                <Grid conteiner
                                                    rowSpacing={0} sx={{
                                                        width: "90vh",
                                                        height: "15.5px",
                                                        display: "inline-flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "strech"
                                                    }}>
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>{titular.juridica ? titular?.denominacionSocial?.toUpperCase() : (titular?.nombre + '   ' + titular?.apellido)?.toUpperCase()}</Typography>
                                                </Grid>
                                                <Divider sx={{ color: "grey", width: "303px", }} />
                                            </Fragment>)
                                    })}
                                </Box>


                                {/* FECHA SUSCRIPCION*/}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "60vh",
                                    // height: "31px",
                                    border: "1px solid grey"
                                }}>
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alingContent: "center"
                                        }}>
                                        <Box width="75px">
                                            <Typography sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>Mes CAC</Typography>
                                        </Box>
                                        <Box alingContent="right" width="75px">
                                            <Typography textAlign="right" sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>{contratos?.suscripcion?.susMesCac}</Typography>
                                        </Box>
                                        <Box width="75px">
                                            <Typography sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>CAC</Typography>
                                        </Box>
                                        <Box alingContent="right" width="75px">
                                            <Typography textAlign="right" sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>{contratos?.suscripcion?.indiceSus}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* SE DIVIDE EN 2 */}
                                <Box sx={{
                                    marginTop: '0px',
                                    width: "60vh",
                                    display: "inline-flex",
                                    justifyContent: "flex-start",
                                }}>

                                    {/* CAJA IZQUIERDA */}
                                    <Box sx={{
                                        width: "45vh",
                                        marginRight: "5px",
                                        alignItems: "flex-end"
                                        // height: "63px",
                                    }}>
                                        {/* ESPACIO */}
                                        <Box sx={{
                                            marginBottom: '8px',
                                            width: "45vh",
                                            display: "inline-flex",
                                            justifyContent: "flex-end"
                                        }}>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>{claseContrato?.principal ? getClaseContratoDescripcion(claseContrato)
                                                : claseContrato?.codigo === 'COCH-STD-QI' ? 'Cochera' : 'Baulera'}</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>{claseContrato?.principal ? 'Cochera' : claseContrato?.codigo === 'COCH-STD-QI' ? 'Est. Profesional' : 'Cochera'}</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>{claseContrato?.principal ? 'Baulera' : claseContrato?.codigo === 'BAUL-STD-QI' ? 'Est. Profesional' : 'Baulera'}</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>Total</Typography>
                                        </Box>


                                        {/* APORTE DE REFERENCIA */}
                                        <Box sx={{
                                            width: "45vh",
                                            marginTop: '0px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech",
                                                    marginBottom: "6px",
                                                    marginTop: "4px",
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "7px",
                                                    }}>${moneyFormatMinuta((((contratos?.planAporte?.apo) * perDpto)?.toFixed(2)))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginLeft: "px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((((contratos?.planAporte?.apo) * perCochera)?.toFixed(2)))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginLeft: "px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((contratos?.planAporte?.apo * perBaulera)?.toFixed(2)))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((((contratos?.planAporte?.apo?.toFixed(2)))))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* PRIMA DE ADJUDICACIÓN */}
                                        <Box sx={{
                                            width: "45vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                        }}>
                                            <Grid align="left" width="45vh" direction="column" conteiner justifyContent="center"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "strech"
                                                }}>
                                                <Typography textAling="center" sx={{
                                                    fontSize: "7px",
                                                    margin: "auto",
                                                    // marginRight: "6px",
                                                    marginTop: "3px",
                                                    marginBottom: "3px",
                                                }}>{contrato?.perPrimaAdjudicacion?.toFixed(2)} %</Typography>
                                                <Grid align="left" width="45vh" conteiner
                                                    sx={{
                                                        display: "inline-flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "strech"
                                                    }}>
                                                    <Grid
                                                        width="10vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                            marginTop: "3px",
                                                            marginBottom: "6px",
                                                        }}>${moneyFormatMinuta(((minutaDpto?.cuotaPrimaAdjudicacionCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                    </Grid>
                                                    <Grid
                                                        width="10vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                            marginTop: "3px",
                                                            marginBottom: "6px",
                                                        }}>${moneyFormatMinuta(((minutaCochera?.cuotaPrimaAdjudicacionCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                    </Grid>
                                                    <Grid
                                                        width="10vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                            marginTop: "3px",
                                                            marginBottom: "6px",
                                                        }}>${moneyFormatMinuta(((minutaBaulera?.cuotaPrimaAdjudicacionCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                    </Grid>
                                                    <Grid
                                                        width="10vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                            marginTop: "3px",
                                                            marginBottom: "6px",
                                                        }}>${moneyFormatMinuta(((minuta?.cuotaPrimaAdjudicacionCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* ADELANTO INICIAL */}
                                        <Box sx={{
                                            width: "45vh",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                        }}>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaDpto?.adelantoInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.bonificacionInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteInicialReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaCochera?.adelantoInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.bonificacionInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteInicialReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaBaulera?.adelantoInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.bonificacionInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteInicialReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minuta?.adelantoInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.bonificacionInicialCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.aporteInicialReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* APORTES MINIMOS PERSONALIZADOS */}
                                        <Box sx={{
                                            width: "45vh",
                                            border: "1px solid grey",
                                            marginTop: "8px"
                                        }}>
                                            <Grid align="center" width="45vh" conteiner
                                                sx={{
                                                    margin: "auto",
                                                }}>
                                                <Typography textAling="center" sx={{
                                                    fontSize: "7px",
                                                    fontWeight: "bold",
                                                    margin: "auto",
                                                    // marginRight: "6px",
                                                }}>{contratos?.personalizacion?.seleccionAguinaldo ? 'Cuota Semestral' : 'Prorrateado Mensualmente'}</Typography>
                                            </Grid>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMinimoEnEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMinimoEnTenenciaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.aguinaldoRefuerzosCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMinimoEnEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMinimoEnTenenciaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.aguinaldoRefuerzosCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMinimoEnEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMinimoEnTenenciaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aguinaldoRefuerzosCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.aporteMinimoEnEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.aporteMinimoEnTenenciaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.aguinaldoRefuerzosCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* APORTES PACTADOS EN AHORRO */}
                                        <Box sx={{
                                            width: "45vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                        }}>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaDpto?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaCochera?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaBaulera?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minuta?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",

                                                    }}>${moneyFormatMinuta(((minuta?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                    </Box>
                                    {/* FIN CAJA IZQUIERDA */}

                                    {/* CAJA DERECHA */}
                                    <Box sx={{
                                        width: "15vh",
                                        marginRight: "5px",
                                        alignItems: "flex-start"
                                    }}>
                                        {/* ESPACIO */}
                                        <Box sx={{
                                            marginTop: '0px',
                                            width: "15vh",
                                            display: "inline-flex",
                                            justifyContent: "flex-end",
                                        }}>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>Grado de Avance</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>Cuotas de Referencia</Typography>
                                        </Box>


                                        {/* APORTE DE REFERENCIA */}
                                        <Box sx={{
                                            width: "15vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech",
                                                    marginBottom: "5px",
                                                    marginTop: "4px",
                                                    marginRight: "6px",
                                                }}>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                    }}>{contratos?.planAporte?.ga?.toFixed(3)} % </Typography>
                                                </Grid>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                    }}>{contratos?.planAporte?.cuo?.toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* PRIMA DE ADJUDICACIÓN */}
                                        <Box sx={{
                                            width: "15vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" direction="column" conteiner justifyContent="center"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "strech"
                                                }}>
                                                <Typography textAling="center" sx={{
                                                    fontSize: "7px",
                                                    margin: "auto",
                                                    color: "white",
                                                    // marginRight: "6px",
                                                    marginTop: "3px",
                                                    marginBottom: "3px",
                                                }}>.</Typography>
                                                <Grid align="right" width="15vh" conteiner
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "flex-end"
                                                    }}>
                                                    <Grid
                                                        width="7vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                            marginTop: "3px",
                                                            marginBottom: "6px",
                                                        }}>{(minuta?.cuotaPrimaAdjudicacionCAC?.ga * 100).toFixed(3)} %</Typography>
                                                    </Grid>
                                                    <Grid
                                                        width="7vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginTop: "3px",
                                                            marginBottom: "6px",
                                                        }}>{(minuta?.cuotaPrimaAdjudicacionCAC?.cuotasReferencia).toFixed(2)}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* ADELANTO INICIAL */}
                                        <Box sx={{
                                            width: "15vh",
                                            marginBottom: '3px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{(minuta?.adelantoInicialCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.bonificacionInicialCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.aporteInicialReconocidoCAC.ga * 100)?.toFixed(3)} %</Typography>
                                                </Grid>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{(minuta?.adelantoInicialCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.bonificacionInicialCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.aporteInicialReconocidoCAC.cuotasReferencia)?.toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* APORTES MINIMOS PERSONALIZADOS */}
                                        <Box sx={{
                                            width: "15vh",
                                            marginTop: '0px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" direction="column" conteiner justifyContent="center"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "strech",
                                                }}>
                                                <Typography textAling="center" sx={{
                                                    fontSize: "7px",
                                                    margin: "auto",
                                                    color: "white",
                                                    // marginRight: "6px",
                                                    marginTop: "3px",
                                                    marginBottom: "6px",
                                                }}>.</Typography>
                                                <Grid align="right" width="15vh" conteiner
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "flex-end"
                                                    }}>
                                                    <Grid
                                                        width="7vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                        }}>{(minuta?.aporteMinimoEnEsperaCAC?.ga * 100)?.toFixed(3)}%</Typography>
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                        }}>{(minuta?.aporteMinimoEnTenenciaCAC?.ga * 100)?.toFixed(3)}%</Typography>
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                            marginRight: "6px",
                                                        }}>{(minuta?.aguinaldoRefuerzosCAC?.ga * 100)?.toFixed(3)}%</Typography>
                                                    </Grid>
                                                    <Grid
                                                        width="7vh"
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="flex-end"
                                                    >
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                        }}>{(minuta?.aporteMinimoEnEsperaCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                        }}>{(minuta?.aporteMinimoEnTenenciaCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                                        <Typography sx={{
                                                            fontSize: "7px",
                                                        }}>{(minuta?.aguinaldoRefuerzosCAC?.cuotasReferencia)?.toFixed(2)}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* APORTES PACTADOS EN AHORRO */}
                                        <Box sx={{
                                            width: "15vh",
                                            marginTop: '0px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{(minuta?.aporteMensualPactadoEsperaCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.bonificacionMensualCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.aporteMensualReconocidoCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.aguinaldoRefuerzosCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                </Grid>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{minuta?.aporteMensualPactadoEsperaCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.bonificacionMensualCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.aporteMensualReconocidoCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.aguinaldoRefuerzosCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                    </Box>
                                    {/* FIN CAJA DERECHA */}
                                </Box>
                            </Box>
                            {/* FIN DATOS CAJA DERECHA */}
                        </Box>
                        <Typography sx={{ fontSize: "7px", fontWeight: "bold" }}>El porcentaje de grado de avance y la cantidad de cuotas de referencia es la misma en todos los contratos</Typography>
                        {/* FOOTER */}
                        <Box sx={{
                            width: "80vh",
                            marginTop: '60px',
                            paddingBottom: "15vh",
                            height: "31px",
                            display: "inline-flex",
                        }}>
                            <Grid conteiner width="175px" direction="column">
                                <Typography textAlign="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>Firma Supervisor Comercial</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>Primera Junta 475, Torre D, Dpto. 602, Sensum</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>Quilmes | Buenos Aires </Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>Argentina</Typography>
                            </Grid>
                            <Grid conteiner width="20vh" direction="column">
                                <Typography textAlign="right" sx={{ fontSize: "7px", marginTop: "12px" }}>www.edilia.com.ar | hola@edilia.com.ar</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>< FaMobileAlt /> <FaWhatsapp />(+ 54 9 11) 3448 9000</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}><FaFacebookSquare /><FaInstagram />@sistemaedilia</Typography>
                            </Grid>
                            <Grid conteiner width="120px" direction="column">
                                <Typography textAlign="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>Firma Cliente</Typography>
                            </Grid>
                        </Box> </> : null}

                    {/* FORM CAMPANA */}
                    {campanaPAEForm && campanaPAEForm?.campanaPAE ? <>
                        {/* SEGUNDA PÁGINA */}

                        <div class="html2pdf__page-break"></div>
                        {/* TÍTULO APORTES X PROODUCTO */}
                        <Grid id="minuta-comercial-cotizador-hoja2" conteiner sx={{ width: "383px", height: "23px", marginTop: "100px", justifyContent: "flex-start", alignItems: "center", gap: "1px", display: "inline-flex" }}>
                            <Grid item>
                                <img style={{ width: "63px", height: "23px" }} src={logo} alt="Logo Edilia" />
                            </Grid>
                            <Grid item>
                                <Typography sx={{ width: "350px", marginLeft: "30vh", color: "black", fontSize: "12px", fontWeight: "bold", color: "#616161" }}>FORMULARIO CAMPAÑA</Typography>
                            </Grid>
                        </Grid>

                        <Box sx={{
                            marginTop: '5px',
                            width: "90vh",
                            display: "inline-flex",
                            justifyContent: "flex-start",
                        }}>

                            {/* TÍTULOS CAJA IZQUIERDA */}
                            <Box sx={{
                                width: "30vh",
                            }}>
                                {/* CAMPANA */}
                                <Box sx={{
                                    width: "30vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    <Grid conteiner
                                        rowSpacing={0} sx={{
                                            width: "90vh",
                                            height: "15.5px",
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Typography sx={{
                                            fontSize: "6px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>CAMPAÑA</Typography>
                                    </Grid>
                                </Box>
                                {/* TITULARES */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '5px',
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    {titulares?.map((titular, i) => {
                                        return (
                                            <Fragment key={'Titular-Titulo' + i}>
                                                <Grid conteiner
                                                    rowSpacing={0} sx={{
                                                        width: "90vh",
                                                        height: "15.5px",
                                                        display: "inline-flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "strech"
                                                    }}>
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>Titular</Typography>
                                                </Grid>
                                                <Divider sx={{ color: "grey", width: "188px", }} />
                                            </Fragment>)
                                    })}
                                </Box>


                                {/* FECHA SUSCRIPCION*/}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "30vh",
                                    // height: "31px",
                                    border: "1px solid grey"
                                }}>
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alingContent: "center"
                                        }}>
                                        <Box width="80px">
                                            <Typography sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>Fecha Suscripción</Typography>
                                        </Box>
                                        <Box alingContent="right">
                                            <Typography textAlign="right" sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>{getFecha(contrato?.fechaCreacion)}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* CAMPANA */}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "30vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    <Grid conteiner
                                        rowSpacing={0} sx={{
                                            width: "90vh",
                                            height: "15.5px",
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Typography sx={{
                                            fontSize: "6px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>MES CUOTA 2</Typography>
                                    </Grid>
                                </Box>
                                {/* ESPACIO */}
                                <Box sx={{
                                    marginTop: '0px',
                                    marginBottom: '0px',
                                    width: "30vh",
                                    display: "inline-flex",
                                    justifyContent: "flex-start"
                                }}>
                                    <Typography align="center" sx={{
                                        width: "15vh",
                                        fontSize: "6px",
                                        marginLeft: "3px",
                                        marginRight: "3px",
                                        color: "white"
                                    }}>.</Typography>
                                </Box>


                                {/* APORTE DE REFERENCIA */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '5px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>APORTE DE REFERENCIA</Typography>
                                    </Box>
                                    <Grid align="left" width="115px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>VALOR CUOTA del PLAN DE APORTES ESTANDAR (PAE)</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* APORTES PACTADOS EN AHORRO */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '9px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>APORTES PACTADOS EN AHORRO</Typography>
                                    </Box>
                                    <Grid align="left" width="120px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                fontWeight: "bold"
                                            }}>APORTE MENSUAL</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>BONIFICACIÓN</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>TOTAL RECONOCIDO</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                            }}>REFUERZOS - ENERO Y JULIO</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {/* DESCUENTO PROMOCIONAL */}
                                <Box sx={{
                                    width: "30vh",
                                    marginTop: '9px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>DESCUENTO PROMOCIONAL</Typography>
                                    </Box>
                                    <Grid align="left" width="120px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                fontWeight: "bold"
                                            }}>CUOTA 1 a 3</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Typography sx={{ fontSize: "4.5px", fontWeight: "bold", fontStyle: 'italic' }}>Todos los decuentos se calculan utilizando el Aporte de Referencia de cada Tipología.</Typography>
                                {/* APORTES 1 a 3 */}
                                <Box sx={{
                                    width: "30vh",
                                    //marginTop: '4px',
                                    // height: "31px",
                                    border: "1px solid grey",
                                    display: "inline-flex",
                                }}>
                                    <Box width="75px" sx={{
                                        backgroundColor: theme.palette.success.main,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>
                                        <Typography align="center" sx={{
                                            fontSize: "7px",
                                            marginLeft: "6px",
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}>APORTES 1 a 3 Luego de Descuento promocional*</Typography>
                                    </Box>
                                    <Grid align="left" width="120px" conteiner
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "space-between",
                                            alignItems: "strech"
                                        }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                        >
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                fontWeight: "bold"
                                            }}>APORTE MENSUAL</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>Bonificación por campaña</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                            }}>Bonificación por Vel. ahorro</Typography>
                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                fontWeight: "bold"
                                            }}>TOTAL RECONOCIDO</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                            {/* FIN CAJA IZQUIERDA */}

                            {/* DATOS CAJA DERECHA*/}
                            <Box sx={{
                                width: "30vh",
                                marginLeft: "5px"
                                // height: "63px",
                            }}>
                                {/* CAMPAÑA */}
                                <Box sx={{
                                    width: "60vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    <Grid conteiner
                                        rowSpacing={0} sx={{
                                            width: "60vh",
                                            height: "15.5px",
                                            display: "inline-flex",
                                            justifyContent: "center",
                                            alignItems: "strech"
                                        }}>
                                        <Typography sx={{
                                            fontSize: "6px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>ALTA TEMPRANA</Typography>
                                    </Grid>
                                </Box>
                                {/* TITULARES */}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "60vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    {titulares?.map((titular, i) => {
                                        return (
                                            <Fragment key={'Titular-nombre-minuta-Form2-' + i}>
                                                <Grid conteiner
                                                    rowSpacing={0} sx={{
                                                        width: "60vh",
                                                        height: "15.5px",
                                                        display: "inline-flex",
                                                        justifyContent: "center",
                                                        alignItems: "strech"
                                                    }}>
                                                    <Typography sx={{
                                                        fontSize: "6px",
                                                        marginLeft: "6px",
                                                        marginRight: "6px"
                                                    }}>{titular.juridica ? titular?.denominacionSocial?.toUpperCase() : (titular?.nombre + '   ' + titular?.apellido)?.toUpperCase()}</Typography>
                                                </Grid>
                                                <Divider sx={{ color: "grey", width: "303px", }} />
                                            </Fragment>)
                                    })}
                                </Box>

                                {/* FECHA SUSCRIPCION*/}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "60vh",
                                    // height: "31px",
                                    border: "1px solid grey"
                                }}>
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alingContent: "center"
                                        }}>
                                        <Box width="75px">
                                            <Typography sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>Mes CAC</Typography>
                                        </Box>
                                        <Box alingContent="right" width="75px">
                                            <Typography textAlign="right" sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>{contratos?.suscripcion?.susMesCac}</Typography>
                                        </Box>
                                        <Box width="75px">
                                            <Typography sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>CAC</Typography>
                                        </Box>
                                        <Box alingContent="right" width="75px">
                                            <Typography textAlign="right" sx={{
                                                fontSize: "6px",
                                                marginLeft: "6px",
                                                marginRight: "6px"
                                            }}>{contratos?.suscripcion?.indiceSus}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* MES CUOTA */}
                                <Box sx={{
                                    marginTop: '5px',
                                    width: "60vh",
                                    // height: "63px",
                                    border: "1px solid grey",
                                }}>
                                    <Grid conteiner
                                        rowSpacing={0} sx={{
                                            width: "60vh",
                                            height: "15.5px",
                                            display: "inline-flex",
                                            justifyContent: "center",
                                            alignItems: "strech"
                                        }}>
                                        <Typography sx={{
                                            fontSize: "6px",
                                            marginLeft: "6px",
                                            marginRight: "6px"
                                        }}>{cuota2}</Typography>
                                    </Grid>
                                </Box>
                                {/* SE DIVIDE EN 2 */}
                                <Box sx={{
                                    marginTop: '0px',
                                    width: "60vh",
                                    display: "inline-flex",
                                    justifyContent: "flex-start",
                                }}>

                                    {/* CAJA IZQUIERDA */}
                                    <Box sx={{
                                        width: "45vh",
                                        marginRight: "5px",
                                        alignItems: "flex-end"
                                        // height: "63px",
                                    }}>
                                        {/* ESPACIO */}
                                        <Box sx={{
                                            marginBottom: '8px',
                                            width: "45vh",
                                            display: "inline-flex",
                                            justifyContent: "flex-end"
                                        }}>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>{claseContrato?.principal ? getClaseContratoDescripcion(claseContrato)
                                                : claseContrato?.codigo === 'COCH-STD-QI' ? 'Cochera' : 'Baulera'}</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>{claseContrato?.principal ? 'Cochera' : claseContrato?.codigo === 'COCH-STD-QI' ? 'Est. Profesional' : 'Cochera'}</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>{claseContrato?.principal ? 'Baulera' : claseContrato?.codigo === 'BAUL-STD-QI' ? 'Est. Profesional' : 'Baulera'}</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>Total</Typography>
                                        </Box>


                                        {/* APORTE DE REFERENCIA */}
                                        <Box sx={{
                                            width: "45vh",
                                            marginTop: '0px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech",
                                                    marginBottom: "6px",
                                                    marginTop: "4px",
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "7px",
                                                    }}>${moneyFormatMinuta((((contratos?.planAporte?.apo) * perDpto)?.toFixed(2)))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginLeft: "px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((((contratos?.planAporte?.apo) * perCochera)?.toFixed(2)))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginLeft: "px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((contratos?.planAporte?.apo * perBaulera)?.toFixed(2)))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((((contratos?.planAporte?.apo?.toFixed(2)))))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* APORTES PACTADOS EN AHORRO */}
                                        <Box sx={{
                                            width: "45vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                        }}>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaDpto?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaCochera?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaBaulera?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minuta?.aporteMensualPactadoEsperaCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.aporteMensualReconocidoCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",

                                                    }}>${moneyFormatMinuta(((minuta?.aguinaldoRefuerzosCAC?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {/* DESCUENTO PROMOCIONAL */}
                                        <Box sx={{
                                            width: "45vh",
                                            marginTop: '9px',
                                            marginBottom: '7px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                        }}>
                                            <Grid sx={{
                                                width: "45vh",
                                                display: "inline-flex",
                                                justifyContent: "center",
                                                alignItems: "strech"
                                            }}
                                            >
                                                <Typography sx={{
                                                    fontSize: "7px",
                                                    marginLeft: "6px",
                                                    marginRight: "6px",
                                                    marginTop: "6px",
                                                    marginBottom: "5px",
                                                    fontWeight: "bold",
                                                }}>{campanaPAEForm ? campanaPAEForm.porcentaje * 100 : '-'}%</Typography>
                                            </Grid>
                                        </Box>
                                        {/* APORTES 1 a 3 */}
                                        <Box sx={{
                                            width: "45vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                        }}>
                                            <Grid align="left" width="45vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaDpto?.aporteMensualCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.bonificacionCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaDpto?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaDpto?.reconocidoCampanaPAE?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaCochera?.aporteMensualCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.bonificacionCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaCochera?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaCochera?.reconocidoCampanaPAE?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minutaBaulera?.aporteMensualCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.bonificacionCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minutaBaulera?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta(((minutaBaulera?.reconocidoCampanaPAE?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                                <Grid
                                                    width="10vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>${moneyFormatMinuta((minuta?.aporteMensualCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.bonificacionCampanaPAE?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>${moneyFormatMinuta((minuta?.bonificacionMensualCAC?.aportes / 100)?.toFixed(2))}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",

                                                    }}>${moneyFormatMinuta(((minuta?.reconocidoCampanaPAE?.aportes) / 100)?.toFixed(2))}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                    </Box>
                                    {/* FIN CAJA IZQUIERDA */}

                                    {/* CAJA DERECHA */}
                                    <Box sx={{
                                        width: "15vh",
                                        marginRight: "5px",
                                        alignItems: "flex-start"
                                    }}>
                                        {/* ESPACIO */}
                                        <Box sx={{
                                            marginTop: '0px',
                                            width: "15vh",
                                            display: "inline-flex",
                                            justifyContent: "flex-end",
                                        }}>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>Grado de Avance</Typography>
                                            <Typography align="center" sx={{
                                                width: "15vh",
                                                fontSize: "6px",
                                                fontWeight: "bold"
                                            }}>Cuotas de Referencia</Typography>
                                        </Box>


                                        {/* APORTE DE REFERENCIA */}
                                        <Box sx={{
                                            width: "15vh",
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech",
                                                    marginBottom: "5px",
                                                    marginTop: "4px",
                                                    marginRight: "6px",
                                                }}>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                    }}>{contratos?.planAporte?.ga?.toFixed(3)} % </Typography>
                                                </Grid>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                    }}>{contratos?.planAporte?.cuo?.toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* APORTES PACTADOS EN AHORRO */}
                                        <Box sx={{
                                            width: "15vh",
                                            marginTop: '0px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{(minuta?.aporteMensualPactadoEsperaCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.bonificacionMensualCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.aporteMensualReconocidoCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.aguinaldoRefuerzosCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                </Grid>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{minuta?.aporteMensualPactadoEsperaCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.bonificacionMensualCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.aporteMensualReconocidoCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.aguinaldoRefuerzosCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {/*DESCUENTO PROMOCIONAL*/}
                                        <Box sx={{
                                            width: "15vh",
                                            marginTop: '9px',
                                            marginBottom: '9px',
                                            // height: "31px",
                                            //border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>

                                            <Typography sx={{
                                                fontSize: "7px",
                                                marginLeft: "6px",
                                                marginRight: "6px",
                                                marginTop: "6px",
                                                marginBottom: "5px",
                                                color: 'white'
                                            }}>.</Typography>
                                        </Box>
                                        {/* APORTES PACTADOS EN AHORRO */}
                                        <Box sx={{
                                            width: "15vh",
                                            marginTop: '0px',
                                            // height: "31px",
                                            border: "1px solid grey",
                                            display: "inline-flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        }}>
                                            <Grid align="left" width="15vh" conteiner
                                                sx={{
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "strech"
                                                }}>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{(minuta?.aporteMensualCampanaPAE?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.bonificacionCampanaPAE?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.bonificacionMensualCAC?.ga * 100)?.toFixed(3)} %</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{(minuta?.reconocidoCampanaPAE?.ga * 100)?.toFixed(3)} %</Typography>

                                                </Grid>
                                                <Grid
                                                    width="7vh"
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="flex-end"
                                                >
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                        fontWeight: "bold"
                                                    }}>{minuta?.aporteMensualCampanaPAE?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.bonificacionCampanaPAE?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.bonificacionMensualCAC?.cuotasReferencia?.toFixed(2)}</Typography>
                                                    <Typography sx={{
                                                        fontSize: "7px",
                                                        marginRight: "6px",
                                                    }}>{minuta?.reconocidoCampanaPAE?.cuotasReferencia?.toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                    </Box>
                                    {/* FIN CAJA DERECHA */}
                                </Box>
                            </Box>
                            {/* FIN DATOS CAJA DERECHA */}
                        </Box>

                        <Box sx={{
                            width: "90vh",
                            marginTop: '60px',
                            paddingBottom: "15vh",
                            height: "31px",
                            display: "inline-flex",
                        }}>
                            <Grid conteiner width="175px" direction="column">
                                <Typography textAlign="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>Firma Supervisor Comercial</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>Primera Junta 475, Torre D, Dpto. 602, Sensum</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>Quilmes | Buenos Aires </Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>Argentina</Typography>
                            </Grid>
                            <Grid conteiner width="20vh" direction="column">
                                <Typography textAlign="right" sx={{ fontSize: "7px", marginTop: "12px" }}>www.edilia.com.ar | hola@edilia.com.ar</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}>< FaMobileAlt /> <FaWhatsapp />(+ 54 9 11) 3448 9000</Typography>
                                <Typography textAlign="right" sx={{ fontSize: "7px", }}><FaFacebookSquare /><FaInstagram />@sistemaedilia</Typography>
                            </Grid>
                            <Grid conteiner width="120px" direction="column">
                                <Typography textAlign="right" sx={{ fontSize: "7px", fontWeight: "bold" }}>Firma Cliente</Typography>
                            </Grid>
                        </Box> </> : null}
                </div >
            </Grid >
        </>
    )
};
